let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("616wv")).then(() => parcelRequire('7Bd71'));